import { AlertUtil } from './../utils/alert-util';
import { AttivitaService } from './../services/attivita.service';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { IAttivita } from '../interfaces/IAttivita';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ISal } from '../interfaces/ISal';
import * as Moment from 'moment';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { Loading } from '../utils/loading';

@Component({
  selector: 'app-new-sal-modal',
  templateUrl: './new-sal-modal.component.html',
  styleUrls: ['./new-sal-modal.component.css']
})
export class NewSalModalComponent implements OnInit {
  newSALform: FormGroup
  objSALByAttivita: IAttivita           //obj from service
  avanzamentoAttuale: number = 0        //percentage of avanzamento from service
  avanzamentoNew: number                //percentage of new avanzamento
  it: any                               // Lingua del calendario

  currentSAL: ISal                    //sal for update
  isNewSAL: boolean                   //determines whether modal was opend for new SAL

  uploadedFiles: any[] = [];            //for upload file
  nameAllegato: string = null           //name allegato

  constructor(private formBuilder: FormBuilder,
    private config: DynamicDialogConfig,
    private attivitaService: AttivitaService,
    private alertUtil: AlertUtil,
    public ref: DynamicDialogRef) {

    this.objSALByAttivita = this.config.data.objSALByAttivita
    this.currentSAL = this.config.data.sal

    this.isNewSAL = !this.currentSAL  //currentSAL undefined means this is a new SAL

    // set nomeAllegato if SAL must be updated
    if (!this.isNewSAL) {
      this.nameAllegato = this.currentSAL.NomeAllegato
    }

    if (this.objSALByAttivita.SAL) {
      this.calculateMaxOfArray();
      this.avanzamentoNew = this.avanzamentoAttuale + 1
    }
    //build form group
    this.newSALform = this.formBuilder.group({
      //'avanzamento': ['', Validators.compose([Validators.required, Validators.min(this.avanzamentoAttuale + 1), Validators.max(100), Validators.minLength(3)])],
      'avanzamento': [!this.isNewSAL ? this.currentSAL.Avanzamento_percentuale : '', Validators.required],
      'data': [!this.isNewSAL ? this.formatDateForCalendar(this.currentSAL.Data) : '', Validators.required],
      'note': [!this.isNewSAL ? this.currentSAL.Note : '']
    })
  }

  ngOnInit() {
    this.setLanguageForCalendar()
  }

  /**
  * language for calendar
  */
  setLanguageForCalendar() {
    /**
    * Lingua italiana nel calendario
    */
    this.it = {
      firstDayOfWeek: 1,
      dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
      today: 'Oggi',
      clear: 'Cancella'
    };
  }

  // convenience getter for easy access to form fields
  get form() { return this.newSALform.controls }

  /**
   * calculate max of array
   */
  calculateMaxOfArray() {
    let avanzamentoArray: number[] = [];
    this.objSALByAttivita.SAL.forEach(itemSAL => {
      avanzamentoArray.push(itemSAL.Avanzamento_percentuale);
    });

    this.avanzamentoAttuale = avanzamentoArray.length > 0 ? this.getMaxOfArray(avanzamentoArray) : 0

  }

  /**
   * return max value of number array
   * @param numArray 
   */
  getMaxOfArray(numArray: number[]): number {
    return Math.max.apply(null, numArray);
  }

  /**
   * format date from YYYY-MM-DDTHH:mm:ss to DD/MM/YYYY
   * @param dateValue item value
   */
  formatDateForSave(dateValue: Date): string {
    return Moment(dateValue).format("YYYY-MM-DDTHH:mm:ss")
  }

  /**
   * format date from YYYY-MM-DDTHH:mm:ss to DD/MM/YYYY
   * @param dateValue 
   */
  formatDateForCalendar(dateValue: string): Date {
    return new Date(dateValue)
  }

  onSubmit() {
    if (this.newSALform.valid) {
      //retrieve values from form
      let avanzamento = this.newSALform.controls['avanzamento'].value
      let data = this.newSALform.controls['data'].value
      let note = this.newSALform.controls['note'].value

      if (this.isNewSAL) {
        //insert new SAL
        let salObj: ISal = {
          Avanzamento_percentuale: avanzamento,
          Data: this.formatDateForSave(data),
          Note: note,
          Attivita: {
            Id: this.objSALByAttivita.Id
          }
        }
        this.callSaveSal(salObj)
      }
      else {
        //update existing SAL
        this.currentSAL.Avanzamento_percentuale = avanzamento
        this.currentSAL.Data = this.formatDateForSave(data)
        this.currentSAL.Note = note

        this.callSaveSal(this.currentSAL)
      }
    }

  }

  /**
   * call save SAL service
   * @param salObj 
   */
  callSaveSal(salObj: ISal) {
    Loading.isLoading = true
    //Creazione della richiesta
    let requestBuilder = new RequestBuilder(salObj, ["Attivita"])
    this.attivitaService.saveSALofAttivita(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          if (this.uploadedFiles && this.uploadedFiles.length > 0) {
            let salSaved: ISal = response.data
            this.callSaveAllegato(salSaved)
          } else {
            this.saveSuccesMessage(response.data)
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * click button allega doc
   * @param event file
   * @param question question selected
   */
  uploadClick(event: any, upload: any) {
    this.uploadedFiles = []
    upload.clear()
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.nameAllegato = this.uploadedFiles[0].name
  }

  /**
  * call service for save allegato
  */
  callSaveAllegato(salSaved: ISal) {
    Loading.isLoading = true
    this.attivitaService.uploadAllegatoSal(this.uploadedFiles[0], this.uploadedFiles[0].name, salSaved.Id.toString()).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) { //return all allegatoObj
          this.saveSuccesMessage(salSaved);
        } else {
          this.alertUtil.showErrorAlert("LBL_ERROR_300")
        }
      })
  }

  /**
   * save success
   */
  saveSuccesMessage(salSaved: ISal) {
    this.alertUtil.showAlert("LBL_SAL_SAVE_SUCCESS", null, null, null, () => {
      this.ref.close(salSaved);
    })
  }

}
